import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/deployment/obituary-app/obituary-fe/app/components/appcomponents/Layout.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/deployment/obituary-app/obituary-fe/app/osmrtnice/ObituaryListContent.tsx");
